export const cn = {
    solutionCard: {
        owner: '所有者',
        label: {
            PAPER: '论文',
            PATENT: '专利',
            WEBSITE: '网站',
            NEWS: '新闻',
            REPORT: '市场报告',
        },
        PAPER: {
            PBD: '出版日期',
        },
        PATENT: {
            APD: '申请日期',
            PBD: '公开日期',
        },
        NEWS: {
            PBD: '发布日期',
        },
        ai_summary: 'AI 核心要点',
        cagr: '复合年均增长率',
        category: '市场类别',
    },
}

export const en = {
    solutionCard: {
        owner: 'Owner',
        label: {
            PAPER: 'Paper',
            PATENT: 'Patent',
            WEBSITE: 'Website',
            NEWS: 'News',
            REPORT: 'Market Report',
        },
        PAPER: {
            PBD: 'Public Date',
        },
        PATENT: {
            APD: 'Application Date',
            PBD: 'Publication Date',
        },
        NEWS: {
            PBD: 'Public Date',
        },
        ai_summary: 'AI Summary',
        cagr: 'CAGR',
        category: 'Market Category',
    },
}

export const jp = {
    solutionCard: {
        owner: '所有者',
        label: {
            PAPER: '論文',
            PATENT: '特許',
            WEBSITE: 'ウェブサイト',
            NEWS: 'ニュース',
            REPORT: '市場報告',
        },
        PAPER: {
            PBD: '出版日',
        },
        PATENT: {
            APD: '申請日',
            PBD: '公開日',
        },
        NEWS: {
            PBD: '発表日',
        },
        ai_summary: 'AI 要約',
        cagr: 'CAGR',
        category: '市場カテゴリ',
    },
}

export const tw = {
    solutionCard: {
        owner: '所有者',
        label: {
            PAPER: '論文',
            PATENT: '專利',
            WEBSITE: '網站',
            NEWS: '新聞',
            REPORT: '市場報告',
        },
        APD: '申請日期',
        PAPER: {
            PBD: '出版日期',
        },
        PATENT: {
            APD: '申請日期',
            PBD: '公開日期',
        },
        NEWS: {
            PBD: '發佈日期',
        },
        ai_summary: 'AI 核心要點',
        cagr: '複合年均增長率',
        category: '市場類別',
    },
}
